export const emptyArr = Object.freeze([]) as never[];

export const emptyObj = Object.freeze({});

export const isApple = !!navigator.platform.match(/iphone|ipad|ipod|mac/i);

/**
 * Returns the number of columns and column width that a CSS grid would have with the given parameters.
 * @param containerWidth The client width (width including padding but excluding scroll bar) of the element containing the grid layout
 * @param containerPadding The left and right padding of the element containing the grid layout
 * @param gridGap The spacing that will be applied between the columns
 * @param minColumnWidth The minimum width that the columns must have. The number of columns is chosen so that the columns
 *     have at least this width (unless the container itself is more narrow than this, in which case 1 is returned).
 */
export function calculateGridColumns({
  containerWidth,
  containerPadding = 0,
  gridGap = 0,
  minColumnWidth,
}: {
  containerWidth: number;
  containerPadding?: number | [number, number];
  gridGap?: number;
  minColumnWidth: number;
}): { columns: number; columnWidth: number } {
  const padding = Array.isArray(containerPadding)
    ? containerPadding
    : [containerPadding, containerPadding];
  const columns = Math.max(
    1,
    Math.ceil((containerWidth - padding[0] - padding[1] + gridGap) / minColumnWidth)
  );
  const columnWidth =
    (containerWidth - padding[0] - padding[1] + gridGap) / columns! - gridGap;
  return { columns, columnWidth };
}

/**
 * An unreachable case that helps ensure the capture of uncovered cases
 * by explictly making typescript error when used in conjunction
 * with a switch statement.
 */
export const unreachable = (value: never) => {
  throw new Error(`Not implemented: ${value}`);
};
